import { render, staticRenderFns } from "./DataModal.vue?vue&type=template&id=70fca738&"
import script from "./DataModal.vue?vue&type=script&lang=js&"
export * from "./DataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports